import { useEffect, useRef, useState } from "react";

function FlipDigit({ d }) {
  const [state, setState] = useState({ cur: d, prev: d, k: 0 });
  const last = useRef(d);
  useEffect(() => {
    if (d !== last.current) {
      setState((s) => ({ cur: d, prev: last.current, k: s.k + 1 }));
      last.current = d;
    }
  }, [d]);
  const { cur, prev, k } = state;
  return (
    <span className="flip-digit" aria-hidden>
      <span className="flip-half flip-top"><span>{cur}</span></span>
      <span className="flip-half flip-bottom"><span>{k ? prev : cur}</span></span>
      {k > 0 && (
        <>
          <span key={`t${k}`} className="flip-half flip-top flip-flap-top"><span>{prev}</span></span>
          <span key={`b${k}`} className="flip-half flip-bottom flip-flap-bottom"><span>{cur}</span></span>
        </>
      )}
    </span>
  );
}

const SIZES = {
  xs: { "--flip-w": "15px", "--flip-h": "22px", "--flip-fs": "15px", "--flip-gap": "2px", "--flip-r": "3px" },
  sm: { "--flip-w": "19px", "--flip-h": "28px", "--flip-fs": "19px", "--flip-gap": "3px", "--flip-r": "4px" },
  lg: { "--flip-w": "44px", "--flip-h": "64px", "--flip-fs": "46px", "--flip-gap": "6px", "--flip-r": "8px" },
  xl: { "--flip-w": "58px", "--flip-h": "84px", "--flip-fs": "62px", "--flip-gap": "8px", "--flip-r": "10px" },
};

/**
 * Split-flap counter. Each digit flips when it changes.
 * value: number | null (null shows dashes while loading)
 */
export default function FlipCounter({ value, digits = 6, size = "sm", label, className = "", groupBy = 0, labelClassName = "" }) {
  const raw = value == null ? "-".repeat(digits) : String(Math.max(0, Math.floor(value))).padStart(digits, "0");
  const chars = raw.split("");
  return (
    <span className={`inline-flex flex-col items-center ${className}`} role="img" aria-label={value == null ? "Loading count" : `${Number(value).toLocaleString("en-IN")}${label ? " " + label : ""}`}>
      <span className="flip" style={SIZES[size] || SIZES.sm}>
        {chars.map((d, i) => (
          <span key={i} className="inline-flex" style={groupBy && i > 0 && (chars.length - i) % groupBy === 0 ? { marginLeft: "calc(var(--flip-gap) * 2)" } : undefined}>
            <FlipDigit d={d}/>
          </span>
        ))}
      </span>
      {label && <span className={`mt-1 leading-none ${labelClassName}`}>{label}</span>}
    </span>
  );
}
